import styled from "styled-components";

export const BackToFirstStepBtn = styled.button`
  position: absolute;
  left: -9rem;
  top: 12px;
  
  @media (max-width: 992px) {
    position: relative;
    left: unset;
    top: unset;
    margin-top: .5rem;
    margin-bottom: 2rem;
  }
`;
